"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var sales_force_input_const_1 = __importDefault(require("./sales_force_input_const")); // Import the missing module
var price_book_utils_1 = __importDefault(require("../../utils/sales_force/price_book_utils"));
var object_utils_1 = __importDefault(require("../../utils/sales_force/object_utils"));
var value_checker_1 = __importDefault(require("../../utils/validation/value_checker"));
var dayjs_1 = __importDefault(require("dayjs"));
var SalesForceInputUtils = /** @class */ (function () {
    function SalesForceInputUtils() {
    }
    SalesForceInputUtils.getDisplayTextList = function (familyName, product2Family, product2Name, forUpgradePreviousPlan) {
        var self_ = this;
        var today = new Date().toLocaleDateString('en-CA');
        // TODO: 2023-12-01 から 2024-03-31 までの期間を定数化すること
        var isLimitedPeriodWithIn = object_utils_1.default.isWithinPeriod('2023-12-01', '2024-03-31', today);
        switch (familyName) {
            case price_book_utils_1.default.FAMILY_ENTRY:
            case price_book_utils_1.default.FAMILY_BASIC:
            case price_book_utils_1.default.FAMILY_MEDIUM:
            case price_book_utils_1.default.FAMILY_STANDARD:
                if (self_.checkWildcardMatch(product2Name, 'Standard') && isLimitedPeriodWithIn) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_MEDIUM;
                }
                // 旧スタンダードからMediumへの洗替データの場合、商談OBJの商品ファミリーはMedium且つ商品OBJの商品ファミリーはStandardである
                // この場合、Mediumとして判定する
                if (familyName === price_book_utils_1.default.FAMILY_MEDIUM && product2Family === price_book_utils_1.default.FAMILY_STANDARD) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_MEDIUM;
                }
                if (self_.checkWildcardMatch(product2Name, 'Entry')) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_ENTRY;
                }
                else if (self_.checkWildcardMatch(product2Name, 'Basic')) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_BASIC;
                }
                else if (self_.checkWildcardMatch(product2Name, 'Medium')) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_MEDIUM;
                }
                else if (self_.checkWildcardMatch(product2Name, 'Standard')) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_STANDARD;
                }
                else {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_SYSTEMS_ERROR;
                }
            case price_book_utils_1.default.FAMILY_UPGRADE:
                if (forUpgradePreviousPlan === price_book_utils_1.default.FAMILY_ENTRY) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_ENTRY;
                }
                else if (forUpgradePreviousPlan === price_book_utils_1.default.FAMILY_BASIC) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_BASIC;
                }
                else if (forUpgradePreviousPlan === price_book_utils_1.default.FAMILY_MEDIUM) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_MEDIUM;
                }
                else if (forUpgradePreviousPlan === price_book_utils_1.default.FAMILY_STANDARD) {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_STANDARD;
                }
                else {
                    return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_SYSTEMS_ERROR;
                }
            default:
                return sales_force_input_const_1.default.UPGRADE_DISPLAY_TEXT_SYSTEMS_ERROR;
        }
    };
    // ワイルドカードによる文字列の一致判定
    SalesForceInputUtils.checkWildcardMatch = function (text, pattern) {
        var regexp = new RegExp(pattern.replace(/\*/g, '.*'));
        return regexp.test(text);
    };
    SalesForceInputUtils.setEkycSkipFlags = function (salesForceInfo, shouldSkip) {
        var flagValue = shouldSkip ? "true" : "";
        salesForceInfo.personalEkycSkipFlg = flagValue;
        salesForceInfo.corporateEkycSkipFlg = flagValue;
    };
    SalesForceInputUtils.getContractStartDate = function (salesForceInfo) {
        if (value_checker_1.default.isPresent(salesForceInfo.entryPrimaryAssignedIdFlg)) {
            return dayjs_1.default(salesForceInfo.applyInfoEntryStartDate + "-01");
        }
        else if (value_checker_1.default.isPresent(salesForceInfo.mediumPrimaryAssignedIdFlg)) {
            return dayjs_1.default(salesForceInfo.applyInfoMediumStartDate + "-01");
        }
        else if (value_checker_1.default.isPresent(salesForceInfo.standardPrimaryAssignedIdFlg)) {
            return dayjs_1.default(salesForceInfo.applyInfoStandardStartDate + "-01");
        }
        else if (value_checker_1.default.isPresent(salesForceInfo.professionalPrimaryAssignedIdFlg)) {
            return dayjs_1.default(salesForceInfo.applyInfoProfessionalStartDate + "-01");
        }
        return null;
    };
    SalesForceInputUtils.checkEkycSkip = function (alreadyEkycLatestRecord, salesForceInfo, inviteMailSentenceType) {
        var self_ = this;
        var exceptingPlanTypes = ['basic', 'motionAi', 'toUpgrade'];
        var hasTablet = inviteMailSentenceType.includes('tablet');
        var isOnlyTablet = inviteMailSentenceType.every(function (type) { return type === 'tablet'; });
        var containsBasicTo = salesForceInfo.toUpgradeSelectedItem.includes("Basic to");
        // アップグレードにおいて、Basic to Medium/Standard/Proの場合は、eKYCを必ず実施する。
        if (containsBasicTo) {
            self_.setEkycSkipFlags(salesForceInfo, false);
            return salesForceInfo;
        }
        if (exceptingPlanTypes.some(function (type) { return inviteMailSentenceType.includes(type); })) {
            self_.setEkycSkipFlags(salesForceInfo, !hasTablet);
            return salesForceInfo;
        }
        if (isOnlyTablet) { // 申込みが有料tabletのみの場合は、eKYCを必ず実施する。
            self_.setEkycSkipFlags(salesForceInfo, false);
            return salesForceInfo;
        }
        // 過去の契約中／契約終了の商談がない場合は、早期returnする。
        if (alreadyEkycLatestRecord === null) {
            return salesForceInfo;
        }
        // 過去の契約中の商談で、アップグレードの場合は、eKYCをスキップする。
        if (alreadyEkycLatestRecord.familyMame === price_book_utils_1.default.FAMILY_UPGRADE && alreadyEkycLatestRecord.contractStatus === '契約中') {
            self_.setEkycSkipFlags(salesForceInfo, true);
            return salesForceInfo;
        }
        if (value_checker_1.default.isBlank(alreadyEkycLatestRecord.contractEndDate)) {
            self_.setEkycSkipFlags(salesForceInfo, true);
            salesForceInfo.isSequentialContractState = "true";
            return salesForceInfo;
        }
        if (value_checker_1.default.isPresent(alreadyEkycLatestRecord.contractEndDate)) {
            var contractEndDate = dayjs_1.default(alreadyEkycLatestRecord.contractEndDate);
            var contractStartdate = self_.getContractStartDate(salesForceInfo);
            var dayBeforeContractStartDate = contractStartdate.subtract(1, 'day');
            if (contractEndDate.isSame(dayBeforeContractStartDate, 'day')) {
                self_.setEkycSkipFlags(salesForceInfo, true);
                salesForceInfo.isSequentialContractState = "true";
                return salesForceInfo;
            }
        }
        return salesForceInfo;
    };
    SalesForceInputUtils.isSequentialContractWithTabletAndMainPlan = function (salesForceInfo, inviteMailSentenceType) {
        var self_ = this;
        var requiredTypes = ['entry', 'medium', 'standard', 'professional'];
        var exceptingPlanTypes = ['basic', 'motionAi', 'toUpgrade'];
        var hasTablet = inviteMailSentenceType.includes('tablet');
        var hasRequiredType = requiredTypes.some(function (type) { return inviteMailSentenceType.includes(type); });
        if (exceptingPlanTypes.some(function (type) { return inviteMailSentenceType.includes(type); })) {
            return salesForceInfo;
        }
        // if (hasTablet && hasRequiredType && ValueChecker.isPresent(salesForceInfo.isSequentialContractState)) {
        //     self_.setEkycSkipFlags(salesForceInfo, true);
        // } else
        if (hasTablet && hasRequiredType) {
            self_.setEkycSkipFlags(salesForceInfo, false);
        }
        return salesForceInfo;
    };
    SalesForceInputUtils.checkMixedEkycRequirement = function (salesForceInfo, inviteMailSentenceType) {
        var self_ = this;
        var requiredTypes = ['entry', 'medium', 'standard', 'professional'];
        var exceptingPlanTypes = ['basic', 'motionAi'];
        var isExceptingPlanTypeIncluded = exceptingPlanTypes.some(function (type) { return inviteMailSentenceType.includes(type); });
        var isRequiredTypeIncluded = requiredTypes.some(function (type) { return inviteMailSentenceType.includes(type); });
        if (isExceptingPlanTypeIncluded && isRequiredTypeIncluded) {
            // exceptingPlanTypesのいずれかの要素が含まれている場合且つ、requiredTypesのいずれかの要素が含まれている場合
            self_.setEkycSkipFlags(salesForceInfo, false);
        }
        return salesForceInfo;
    };
    return SalesForceInputUtils;
}());
exports.default = SalesForceInputUtils;



//////////////////
// WEBPACK FOOTER
// ./common/src/constrains/sales_force_input/sales_force_input_utils.ts
// module id = THWO
// module chunks = 1